import { Card, Flex, Grid, Loader, Text } from '@mantine/core';
import { useGetScanStatsQuery } from './graphql.generated';

export const ScanStats = () => {
	const { data, loading, error } = useGetScanStatsQuery();

	if (loading) {
		return <Loader />;
	}
	if (error) {
		return <div>Error: {error.message}</div>;
	}

	const scanStats = data?.getScanStats;
	if (!scanStats) {
		return <div>No scan statistics available</div>;
	}

	return (
		<>
			<Flex direction="column" align="flex-start" w="100%" pb="lg" px="sm" gap="sm">
				<Text size="lg" fw={900}>
					Our Impact
				</Text>
				<Text size="md" fw={700} c="#5E6262">
					See how far we've come together.
				</Text>
				<Text size="sm">Since our launch in 2021:</Text>
			</Flex>
			<Grid gutter="md" w="100%">
				<Grid.Col span={{ base: 12, sm: 6 }} pb="lg">
					<Card
						shadow="none"
						padding="lg"
						radius="md"
						withBorder
						h="100%"
						w="100%"
						styles={{
							root: {
								border: '1px solid var(--mantine-color-blue-0)',
								borderRadius: '8px',
							},
						}}
					>
						<Flex direction="column" align="center" gap="xs" justify="center" h="100%">
							<Text size="xl" fw={900} c="blue.9" ta="center">
								{scanStats.totalScans.toLocaleString()}
							</Text>
							<Text size="sm" c="blue.9" ta="center" h={40}>
								Total number of scans nationwide
							</Text>
						</Flex>
					</Card>
				</Grid.Col>
				<Grid.Col span={{ base: 12, sm: 6 }} pb="lg">
					<Card
						shadow="none"
						padding="lg"
						radius="md"
						withBorder
						h="100%"
						w="100%"
						styles={{
							root: {
								border: '1px solid var(--mantine-color-blue-0)',
								borderRadius: '8px',
							},
						}}
					>
						<Flex direction="column" align="center" gap="xs" justify="center" h="100%">
							<Text size="xl" fw={900} c="blue.9" ta="center">
								{scanStats.totalScansForCouncil.toLocaleString()}
							</Text>
							<Text size="sm" c="blue.9" ta="center" h={40}>
								Total number of scans from your council area
							</Text>
						</Flex>
					</Card>
				</Grid.Col>
			</Grid>
		</>
	);
};
